import {useTranslation} from "react-i18next";
import MatchBox from "../../matches/MatchBox";
import {getHallOfFameMatchRatingId} from "../../../util/HelperUtils";
import type {HallOfFameRecord} from "../../../types/domain";

interface TopMatchesTabProps {
    records: HallOfFameRecord[];
}

function TopMatchesTab(props: TopMatchesTabProps) {
    const { t } = useTranslation();

    return (
        <>
            <div className="match-records-grid">
                {props.records.map(record => (
                  <div key={"match-record-" + record.category} className="mb-5 match-record">
                      <div className="text-center">
                          <h5>{t(`record_${record.category}`)}</h5>
                      </div>
                      <div className="justify-content-center">
                          {record.entries.map((entry) => entry.match && (
                            <div style={{maxWidth: "720px", margin: "auto"}} key={"match-box-" + entry.match.id} className="shine-on-hover">
                                <MatchBox match={entry.match} ratingId={getHallOfFameMatchRatingId(record.category, entry.match)} />
                            </div>
                          ))}
                      </div>
                  </div>
                ))}
            </div>
        </>
    );
}

export default TopMatchesTab
